import { useQueryStates, parseAsStringEnum } from 'nuqs'
import { useCallback } from 'react'
import { parseAsZonedDate } from 'lib/nuqs/parseAsZonedDate'

export const useTimeRangeQueryState = () => {
  const [state, setState] = useQueryStates(
    {
      startDate: parseAsZonedDate,
      endDate: parseAsZonedDate,
      type: parseAsStringEnum(['past', 'ongoing', 'upcoming'] as const),
    },
    {
      urlKeys: {
        startDate: 'start-date',
        endDate: 'end-date',
        type: 'range-type',
      },
    }
  )
  const set = useCallback(
    (value: {
      startDate?: Date | null
      endDate?: Date | null
      type?: 'past' | 'ongoing' | 'upcoming' | null
    }) =>
      setState({
        startDate: value?.startDate ?? null,
        endDate: value?.endDate ?? null,
        type: value.type ?? null,
      }),
    [setState]
  )

  const queryState = {
    startDate: state.startDate ?? undefined,
    endDate: state.endDate ?? undefined,
    type: state.type === null ? undefined : state.type,
  }

  return [queryState, set] as const
}
